import {lazy} from "react"

export const PaymentPayPal = lazy(() =>
  import("./PaymentPayPal").then(module => ({default: module.PaymentPayPal}))
)

export const PaymentStripeWallet = lazy(() =>
  import("./PaymentStripeWallet").then(module => ({default: module.PaymentStripeWallet}))
)

export const PaymentStripeCard = lazy(() =>
  import("./PaymentStripeCard").then(module => ({default: module.PaymentStripeCard}))
)